import { render, staticRenderFns } from "./PriceComponent.vue?vue&type=template&id=7c75b418"
import script from "./PriceComponent.vue?vue&type=script&lang=js"
export * from "./PriceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports